module.exports = __webpack_public_path__ + "img/ro3.2ecf1361.jpg";